import _ from 'lodash';

window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from 'axios';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import $ from './jquery.js'; // jQuery burada global hale gelir

import 'inputmask';
import 'jquery-ui-dist/jquery-ui.min.js';
import 'jquery-migrate';
import 'jquery-number';

import 'bootstrap';

import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_tr.min.js';
import './assets/validation.js';

import select2Factory from 'select2/dist/js/select2.full.js';

select2Factory(window, $);

$.fn.select2.defaults.set('language', 'tr');

import './assets/scripts.js';

import ('./assets/slidebars.js').then(() => {
    $.slidebars();
});

import DataTable from 'datatables.net-bs';
import 'datatables.net-autofill-bs';
import 'datatables.net-buttons-bs';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-colreorder-bs';
import 'datatables.net-fixedcolumns-bs';
import 'datatables.net-fixedheader-bs';
import 'datatables.net-keytable-bs';
import 'datatables.net-rowgroup-bs';
import 'datatables.net-rowreorder-bs';
import 'datatables.net-scroller-bs';
import 'datatables.net-searchbuilder-bs';
import 'datatables.net-searchpanes-bs';
import 'datatables.net-select-bs';
import 'datatables.net-staterestore-bs';

$.extend(true, $.fn.dataTable.defaults, {
    language: {
        emptyTable: "Tabloda herhangi bir veri mevcut değil",
        search: "Ara:",
        lengthMenu: "Sayfa başına _MENU_ kayıt göster",
        info: "_TOTAL_ kayıttan _START_ - _END_ arasındaki kayıtlar gösteriliyor",
        infoEmpty: "Gösterilecek kayıt yok",
        paginate: {
            'sFirst': '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
            'sPrevious': '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            'sNext': '<i class="fa fa-angle-right" aria-hidden="true"></i>',
            'sLast': '<i class="fa fa-angle-double-right" aria-hidden="true"></i>'
        },
        loadingRecords: "Yükleniyor...",
        processing: 'İşleniyor..',
        zeroRecords: "Eşleşen kayıt bulunamadı",
        infoFiltered: "(_MAX_ kayıt içerisinden filtrelendi)"
    }
});

window.DataTable = DataTable;

import datepicker from 'bootstrap-datepicker';
import './assets/bootstrap-datetimepicker.js';

window.datepicker = datepicker;

import 'jquery-steps/build/jquery.steps.min.js';

$.extend($.fn.steps.defaults.labels, {
    cancel: "İptal",
    current: "Şu anki Durum:",
    pagination: "Sayfalama",
    finish: "Tamamla",
    next: "Devam Et",
    previous: "Geri Dön",
    loading: "Yükleniyor..."
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});

import Swal from 'sweetalert2';

window.Swal = Swal;

import './toastr.js';

import {
    Chart,
    ArcElement,
    Tooltip,
    Legend,
    PieController
} from 'chart.js';

Chart.register(PieController, ArcElement, Tooltip, Legend);

window.Chart = Chart;

import 'jqvmap/dist/jquery.vmap';
import 'jqvmap/dist/maps/jquery.vmap.turkey';

import 'jquery.countdown';

window.countdown = startCountdown;

// Bu fonksiyon default ayarları değiştirip, sonra sayacı başlatır
function startCountdown(selector, options) {
    const defaults = {
        css_class: 'countdown vertical-timer',
        always_show_days: false,
        with_labels: true,
        with_seconds: true,
        with_separators: true,
        with_hh_leading_zero: true,
        with_mm_leading_zero: true,
        with_ss_leading_zero: true,
        label_dd: 'gün',
        label_hh: 'saat',
        label_mm: 'dakika',
        label_ss: 'saniye',
        separator: ' ',
        separator_days: ' '
    };
    const settings = $.extend({}, defaults, options);

    $(selector).countDown(settings);
}

import {
    ClassicEditor,
    SourceEditing,
    Essentials,
    Paragraph,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    Font,
    Heading,
    Link,
    List,
    Indent,
    Alignment,
    BlockQuote,
    Image,
    ImageToolbar,
    ImageStyle,
    ImageResize,
    ImageCaption,
    ImageUpload,
    Base64UploadAdapter,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    TableColumnResize,
    PasteFromOffice,
    HorizontalLine,
    Autoformat,
    RemoveFormat,
    GeneralHtmlSupport
} from 'ckeditor5';

import coreTranslations from 'ckeditor5/translations/tr.js';

const editors = {}; // store editor instances by ID or index

document.querySelectorAll('.ckeditor').forEach((el, index) => {
    ClassicEditor
        .create(el, {
            licenseKey: 'GPL',
            placeholder: 'İçeriği buraya yazın!',
            plugins: [
                SourceEditing, Essentials, Paragraph, Bold, Italic, Underline, Strikethrough, Code,
                Subscript, Superscript, Font, Heading, Link, List, Indent, Alignment,
                BlockQuote, Image, ImageToolbar, ImageStyle, ImageResize, ImageCaption, ImageUpload,
                Table, TableToolbar, TableProperties, TableCellProperties, TableColumnResize,
                PasteFromOffice, HorizontalLine, RemoveFormat, Autoformat, Base64UploadAdapter, GeneralHtmlSupport
            ],
            toolbar: [
                'sourceEditing', 'heading', '|',
                'bold', 'italic', 'underline', 'strikethrough', 'code', '|',
                'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
                'link', 'bulletedList', 'numberedList', 'outdent', 'indent', '|',
                'alignment', 'blockQuote', 'horizontalLine', 'imageUpload', '|',
                'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties', '|',
                'undo', 'redo', 'removeFormat'
            ],
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells',
                    'tableProperties',
                    'tableCellProperties'
                ]
            },
            image: {
                toolbar: [
                    'imageStyle:inline',
                    'imageStyle:block',
                    'imageStyle:side',
                    '|',
                    'toggleImageCaption',
                    'imageTextAlternative'
                ]
            },
            htmlSupport: {
                allow: [
                    {
                        name: /.*/, // tüm etiketler için geçerli
                        styles: true,
                        classes: true,
                        attributes: true
                    }
                ]
            },
            translations: [
                coreTranslations
            ]
        })
        .then(editor => {
            const id = el.getAttribute('id') || `editor-${index}`;

            editors[id] = editor;
        });
});

window.editors = editors;

$.fn.fileinputBsVersion = '3.3.7';

import "bootstrap-fileinput/js/fileinput.js";
import "bootstrap-fileinput/js/locales/tr.js";

window.fileInputExcel = fileInputExcel;

function fileInputExcel(element, ftpElement) {
    element.fileinput({
        theme: 'explorer-fa4',
        language: 'tr',
        destroy: true,
        previewFileType: "any",
        showUpload: true,
        uploadUrl: window.routeFtpExcel,
        uploadExtraData: function (previewId, index) {
            return {
                '_token': $('#csrf_token').val(),
                ftpDisk: ftpElement.find(':selected').data('disk'),
                ftpPath: ftpElement.find(':selected').data('path')
            };
        },
        allowedFileExtensions: ['xls', 'xlsx'],
        initialPreviewAsData: true,
        overwriteInitial: false,
        browseOnZoneClick: true,
        removeFromPreviewOnError: true,
        fileActionSettings: {
            showRotate: false,
            showZoom: false
        },
        preferIconicPreview: true,
        previewFileIconSettings: { // configure your icon file extensions
            'doc': '<i class="fa fa-file-word-o text-primary"></i>',
            'xls': '<i class="fa fa-file-excel-o text-success"></i>',
            'ppt': '<i class="fa fa-file-powerpoint-o text-danger"></i>',
            'pdf': '<i class="fa fa-file-pdf-o text-danger"></i>',
            'zip': '<i class="fa fa-file-archive-o text-muted"></i>',
            'htm': '<i class="fa fa-file-code-o text-info"></i>',
            'txt': '<i class="fa fa-file-text-o text-info"></i>',
            'mov': '<i class="fa fa-file-video-o text-warning"></i>',
            'mp3': '<i class="fa fa-file-audio-o text-warning"></i>',
            'jpg': '<i class="fa fa-file-image-o text-danger"></i>',
            'gif': '<i class="fa fa-file-image-o text-muted"></i>',
            'png': '<i class="fa fa-file-image-o text-primary"></i>'
        },
        previewFileExtSettings: {
            'doc': function (ext) {
                return ext.match(/(doc|docx)$/i);
            },
            'xls': function (ext) {
                return ext.match(/(xls|xlsx)$/i);
            },
            'ppt': function (ext) {
                return ext.match(/(ppt|pptx)$/i);
            },
            'zip': function (ext) {
                return ext.match(/(zip|rar|tar|gzip|gz|7z)$/i);
            },
            'htm': function (ext) {
                return ext.match(/(htm|html)$/i);
            },
            'txt': function (ext) {
                return ext.match(/(txt|ini|csv|java|php|js|css)$/i);
            },
            'mov': function (ext) {
                return ext.match(/(avi|mpg|mkv|mov|mp4|3gp|webm|wmv)$/i);
            },
            'mp3': function (ext) {
                return ext.match(/(mp3|wav)$/i);
            }
        }
    }).on('fileselect', function (event, numFiles, label) {
        // if ($(this).val().length > 0) {
        //     let currentFileName = ftpElement.find(':selected').data('name');
        //
        //     if (currentFileName !== label) {
        //         // input'u doğrudan temizle
        //         $(this).fileinput('clear');
        //         // Bazen val('') eklemek de fayda sağlar
        //         $(this).val('');
        //
        //         toastError('Dosyanızın ismi şu şekilde olmalıdır: ' + currentFileName);
        //     }
        // }
    }).on('fileuploaderror', function (event, data, msg) {
        toastError(msg);
    }).on('fileuploaded', function (event, previewId, index, fileId) {
        toastSuccess('Dosyalar siteye yüklenmiştir.');
    }).on('filebatchuploadcomplete', function (event, preview, config, tags, extraData) {
        // Dosyayı temizle
        element.val(''); // HTML input'u temizle
        element.fileinput('clear').fileinput('reset');
    });
}

$(document).ready(function () {
    if ($('body').hasClass('layout-guest')) {
        return;
    }

    if (window.superAdmin) {
        console.log('🔑 Süper admin olarak bağlanılıyor...');

        window.Echo.private('hi.superadmin')
            .listen('.notification', (data) => {
                Livewire.dispatch('notificationAddDatabase', { siteId: data.siteId });
            });
    } else {
        const processed = new Set();

        $('select[name^="siteSelect"] option').each(function () {
            const siteId = $(this).val();
            if (!siteId || processed.has(siteId)) return;
            processed.add(siteId);

            const channelName = `hi.${siteId}`;

            // 🎯 Daha önce dinliyorsa kapat
            if (window.Echo.connector.channels[`private-${channelName}`]) {
                window.Echo.leaveChannel(`private-${channelName}`);
            }

            window.Echo.private(channelName)
                .listen('.notification', (data) => {
                    Livewire.dispatch('notificationAddDatabase', { siteId: data.siteId });
                });
        });
    }
});


